import { AppHomeComponent } from './home.component';
import { AppMaterialModule } from '../../app-material.module';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [CommonModule, RouterModule, AppMaterialModule, FormsModule],
  declarations: [AppHomeComponent],
  exports: [AppHomeComponent],
})
export class AppHomeModule {}
